import { Component, Input } from '@angular/core';
import { Formatter } from '@aptitude/shared-vanilla';
import { AbbreviatedNumberWithSuffixPipe } from '@aptitude/angular-pipes';

import { SummaryRollupWrapperService } from './summary-rollup-wrapper/summary-rollup-wrapper.service';

@Component({
    selector: 'app-summary-rollup-card',
    templateUrl: './summary-rollup-card.component.html',
    styleUrls: ['./summary-rollup-card.component.scss'],
    standalone: false
})
export class SummaryRollupCardComponent {
  @Input() headingText = '';
  @Input() mainText: number | string = 0;
  @Input() mainClass?: string;
  @Input() underText = '';
  @Input() isApproximate = false;
  @Input() formatType: 'currency' | 'number' | 'none' = 'currency';
  @Input() tooltipText = '';

  displayFullValue = false;
  animTimer: any;

  constructor(
    private summaryRollupWrapperService: SummaryRollupWrapperService,
    private abbreviatedNumberWithSuffixPipe: AbbreviatedNumberWithSuffixPipe,
  ) {
    this.summaryRollupWrapperService.displayFullValue$.subscribe(
      (displayFullValue) => {
        this.displayFullValue = displayFullValue;
      },
    );
  }

  formatMainText() {
    switch (this.formatType) {
      case 'currency':
        return this.isApproximate
          ? this.formatApproximate(Formatter.currency(this.mainText as number))
          : Formatter.currency(this.mainText as number);
      case 'number':
        return Formatter.number(this.mainText as number);
      case 'none':
        return this.mainText;
    }
  }

  formatAbbreviatedMainText() {
    switch (this.formatType) {
      case 'currency':
        return this.isApproximate
          ? `${this.formatApproximate(
              this.abbreviatedNumberWithSuffixPipe.transform(
                this.mainText as number,
              ),
            )}`
          : `$${this.abbreviatedNumberWithSuffixPipe.transform(
              this.mainText as number,
            )}`;
      case 'number':
        return this.abbreviatedNumberWithSuffixPipe.transform(
          this.mainText as number,
        );
      case 'none':
        return this.mainText;
    }
  }

  onMouseOver() {
    this.animTimer = setTimeout(() => {
      this.summaryRollupWrapperService.setDisplayFullValue(true);
    }, 1000);
  }

  onMouseOut() {
    clearTimeout(this.animTimer);
    this.summaryRollupWrapperService.setDisplayFullValue(false);
  }

  getTooltipText(): string {
    return this.isApproximate ? this.tooltipText : '';
  }

  private formatApproximate(value: string): string {
    if (value.charAt(0) === '$') {
      value = value.substring(1);
    }
    return `** $${value}`;
  }
}
